import { render, staticRenderFns } from "./userinfo.vue?vue&type=template&id=4d2307ea"
import script from "./userinfo.ts?vue&type=script&lang=js&external"
export * from "./userinfo.ts?vue&type=script&lang=js&external"
import style0 from "./userinfo.vue?vue&type=style&index=0&id=4d2307ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports